'use client';

import { c as _c } from "react/compiler-runtime";
import { useFinancesYear } from '../../hooks/use-finances-year';
import { TitleSectionFinances } from '../title-section-finances';
import { BreakdownTableFilters } from './breakdown-table-filters';
import { TableBody } from './table-body';
import { TableHeader } from './table-header';
import { useBreakdownTable } from './use-breakdown-table';
function BreakdownTable() {
  const $ = _c(19);
  const {
    year
  } = useFinancesYear();
  const range = `Jan - Dec ${year}`;
  const {
    filters,
    isLoading,
    selectedGranularity,
    tableHeader,
    tableBody,
    activeMetrics
  } = useBreakdownTable();
  let t0;
  if ($[0] !== range) {
    t0 = range.toUpperCase();
    $[0] = range;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <TitleSectionFinances title="Breakdown Table" hash="breakdown-table" tooltipContent="The breakdown table enhances the functionality of the breakdown chart by providing a side-by-side multi-metric comparison. It delivers a detailed view with subtotals for each budget category and their subdivisions, along with a cumulative total for selected metrics." range={t0} />;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== filters) {
    t2 = <BreakdownTableFilters filters={filters} />;
    $[4] = filters;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <div className="flex w-full items-center justify-between gap-4">{t1}{t2}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== activeMetrics || $[10] !== isLoading || $[11] !== selectedGranularity || $[12] !== tableBody || $[13] !== tableHeader || $[14] !== year) {
    t4 = isLoading ? <div>Loading...</div> : <div><div><TableHeader granularity={selectedGranularity} title="Sky Budget" year={year} headerTable={tableHeader ?? []} activeMetrics={activeMetrics} /></div>{tableBody && <div className="mt-4 flex flex-col gap-4 xl:mt-2 xl:gap-2"><TableBody tableBody={tableBody} activeMetrics={activeMetrics} granularity={selectedGranularity} /></div>}</div>;
    $[9] = activeMetrics;
    $[10] = isLoading;
    $[11] = selectedGranularity;
    $[12] = tableBody;
    $[13] = tableHeader;
    $[14] = year;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== t3 || $[17] !== t4) {
    t5 = <div>{t3}{t4}</div>;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
}
export { BreakdownTable };